<template>
<v-card flat>
  <v-date-picker
    v-model='date'
    @click:month='displayType="date"'
    :type='displayType'
    :max='new Date().toISOString().substr(0, 10)'
    min='1900-01-01'
    class='elevation-0'
    full-width flat >
  </v-date-picker>
  <v-divider></v-divider>
  <v-card-actions >
    <v-spacer></v-spacer>
    <v-btn @click='$emit("close")' flat >{{ $t('buttons.done') }}</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
export default {
  name: 'BirthdayPicker',
  props: {
    value: { type: String }
  },
  data () {
    return {
      date: '1975',
      displayType: 'year'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.date = this.value
        }
      }
    },
    date () {
      this.$emit('input', this.date)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// BirthdayPicker.vue?448d3e00